import { useAuthContext } from '../../contexts/AuthContext';
import { useErrorMessage } from '../../utils/errorMessage';
import { useFetchEnums } from '../../utils/useFetchEnums';
import { personalInformations } from './fields/personalInformationsFields';
import { additionalInformations } from './fields/additionalInformationsFields';
import { extraInformations } from './fields/extraInformationsFields';

export const useFields = ({
  filesList,
  setFilesList,
  setShowSecondProfile,
  showSecondProfile,
  form,
  setInternetAccess,
  internetAccess,
  isChildren,
  isGrandChildren,
  setIsChildren,
  setIsGrandChildren,
  setRemovedFiles,
  country,
  setCountry
}) => {
  const { message } = useErrorMessage();
  const { dispatchAPI } = useAuthContext();
  const { enums, isFieldsLoading } = useFetchEnums('/pensioners/enums', {
    dispatchAPI,
    message
  });
  const { personnalInformationsFields } = personalInformations({
    filesList,
    setFilesList,
    enums,
    isFieldsLoading,
    setShowSecondProfile,
    showSecondProfile,
    setRemovedFiles
  });
  const { additionalInformationsFields } = additionalInformations({
    filesList,
    setFilesList,
    isFieldsLoading,
    form,
    setInternetAccess,
    internetAccess,
    setRemovedFiles,
    country,
    setCountry
  });
  const { extraInformationsFields } = extraInformations({
    enums,
    isFieldsLoading,
    isChildren,
    isGrandChildren,
    setIsChildren,
    setIsGrandChildren
  });

  return {
    personnalInformationsFields,
    additionalInformationsFields,
    extraInformationsFields,
    isFieldsLoading
  };
};
